import type PlainDate from '@Domain/PlainDate';
import type AiCostsFilterView from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';

/** A monthly limit speaks of the current month when the period starts in it. */
const isCurrentMonthPeriod = (filters: AiCostsFilterView, today: PlainDate): boolean =>
	filters.from.year === today.year && filters.from.month === today.month;

export default isCurrentMonthPeriod;
